import React, { useState, useEffect } from "react";
import SwapVertIcon from "@mui/icons-material/SwapVert";
function Table(props) {
  console.log("second render");
  const {
    data,
    checkBoxShow,
    mapData,
    PerPage,
    Page,
    type,
    style,
    onChildValue,
    selectAllChecked,
    handleSelectAll,
  } = props;

  const [sortColumn, setSortColumn] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [checkBox, setCheckBox] = useState();
  let [sortedData, setSortedData] = useState([]);
  useEffect(() => {
    setSortedData(data);
  }, [data]);

  // sortedData =
  //   data?.length > 0 &&
  //   data?.sort((a, b) => {
  //     const valueA = a[sortColumn];
  //     const valueB = b[sortColumn];

  //     if (valueA < valueB) {
  //       return sortOrder === "asc" ? -1 : 1;
  //     }
  //     if (valueA > valueB) {
  //       return sortOrder === "asc" ? 1 : -1;
  //     }
  //     return 0;
  //   });
  // useEffect(() => {
  //   setSortedData(sortedData || []);
  //   console.log(sortedData);
  // }, [sortedData]);
  //handlig sort if feature is true and undefined
  const handleSortFeature = () => {
    const newOrder = sortOrder === "asc" ? "dsc" : "asc";
    setSortOrder(newOrder);

    const sorted = [...data].sort((a, b) => {
      const featureA = a.feature === true ? 1 : 0;
      const featureB = b.feature === true ? 1 : 0;
      return newOrder === "asc" ? featureA - featureB : featureB - featureA;
    });

    setSortedData(sorted);
  };
  const handleRemainingSort = (value) => {
    const newOrder = sortOrder === "asc" ? "dsc" : "asc";
    setSortOrder(newOrder);

    const sorted = [...data].sort((a, b) => {
      const tagA = a[value]?.toLowerCase() || "";
      const tagB = b[value]?.toLowerCase() || "";

      return newOrder === "asc"
        ? tagA.localeCompare(tagB)
        : tagB.localeCompare(tagA);
    });

    setSortedData(sorted);
  };
  // Slice the data if it's defined
  const startIndex = (Page - 1) * PerPage;
  const endIndex = startIndex + PerPage;
  const currentPageData = data && data?.slice(startIndex, endIndex);

  return (
    <>
      <div className="primeMain table-custom">
        <table
          width="100%"
          border
          className="primeTable text-center"
          style={{ maxHeight: "600px" }}
        >
          <thead
            className=""
            style={{ zIndex: "1", position: "sticky", top: "0" }}
          >
            <tr>
              {mapData?.map((res) => {
                return (
                  <th className="fw-bold text-nowrap">
                    <div className="table-head">
                      {res?.Header === "checkBox" ? (
                        <input
                          type="checkbox"
                          checked={selectAllChecked}
                          onChange={handleSelectAll}
                        />
                      ) : res?.Header === "Feature Tag" ? (
                        <div className="d-flex">
                          <SwapVertIcon onClick={handleSortFeature} />
                          <div className="ps-2">{`${""}${res?.Header}`}</div>
                        </div>
                      ) : res?.Header === "Hashtag" ? (
                        <div className="d-flex">
                          <SwapVertIcon
                            onClick={() => {
                              handleRemainingSort("hashTag");
                            }}
                          />
                          <div className="ps-2">{`${""}${res?.Header}`}</div>
                        </div>
                      ) : (
                        `${" "}${res?.Header}`
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>

          {type == "server" && (
            <>
              <tbody>
                {sortedData?.length > 0 ? (
                  <>
                    {(PerPage > 0
                      ? [sortedData].slice(
                          Page * PerPage,
                          Page * PerPage + PerPage
                        )
                      : sortedData
                    ).map((i, k) => {
                      return (
                        <>
                          <tr>
                            {mapData.map((res) => {
                              return (
                                <td key={k}>
                                  {res.Cell ? (
                                    <res.Cell row={i} index={k} />
                                  ) : (
                                    <span className={res.class}>
                                      {i[res.body]}
                                    </span>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan="25"
                      className="text-center"
                      style={{ height: "358px", borderBottom: "none" }}
                    >
                      No Data Found !
                    </td>
                  </tr>
                )}
              </tbody>
            </>
          )}

          {type == "client" && (
            <>
              <tbody>
                {currentPageData?.length > 0 ? (
                  <>
                    {currentPageData?.map((i, k) => {
                      return (
                        <>
                          <tr>
                            {mapData.map((res) => {
                              return (
                                <td>
                                  {res.Cell ? (
                                    <res.Cell row={i} index={k} />
                                  ) : (
                                    <span className={res.class}>
                                      {i[res.body]}
                                    </span>
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td
                      colSpan="16"
                      className="text-center"
                      style={{ height: "358px", borderBottom: "none" }}
                    >
                      No Data Found !
                    </td>
                  </tr>
                )}
              </tbody>
            </>
          )}
        </table>
      </div>
    </>
  );
}

export default Table;
